import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { StatusTag } from 'components/StatusTag';
import { AtlasGqlTurbine } from 'types/atlas-graphql';
import { TInspectionData } from 'components/FleetMap/types';
import {
  SeverityContainer,
  StyledCircle,
} from 'components/FleetMap/TurbinePointMap/TurbinesList/TurbinesList.Styles';

const LinkLabel = styled.span`
  font-size: 0.9rem;
  min-width: 3rem;
  margin-right: 0.5rem;
`;

const LinkTitle = styled.span`
  font-size: 0.9rem;
`;

const StaticLabel = styled.span`
  font-size: 0.9rem;
  margin: 0;
`;

const RowContainer = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
`;

interface FleetMapDetailProps {
  turbine: AtlasGqlTurbine | null;
  previewMode?: boolean;
  inspectionData?: TInspectionData;
}

const FleetMapDetail: FC<FleetMapDetailProps> = ({ turbine, previewMode, inspectionData }) => {
  const [lat, lng] = turbine?.latLng ?? [];

  return (
    <>
      {turbine?.location && previewMode && (
        <RowContainer data-testid="fleet-map-detail">
          <LinkLabel>Site:</LinkLabel>
          <Link to={`sites/${turbine.location?.id}`}>
            <LinkTitle>{turbine.location?.name}</LinkTitle>
          </Link>
        </RowContainer>
      )}
      {turbine ? (
        <>
          <RowContainer data-testid="fleet-map-detail">
            <LinkLabel>Turbine:</LinkLabel>
            {previewMode ? (
              <StaticLabel>{turbine.name}</StaticLabel>
            ) : (
              <Link to={`/turbines/${turbine.id}`} target="_blank" rel="noopener noreferrer">
                <LinkTitle>{turbine.name}</LinkTitle>
              </Link>
            )}
          </RowContainer>

          {previewMode ? (
            <>
              <RowContainer>
                <LinkLabel />
                {turbine.status ? <StatusTag value={turbine.status} /> : null}
              </RowContainer>
              <RowContainer>
                <LinkLabel>Lat:</LinkLabel>
                <StaticLabel>{lat}</StaticLabel>
              </RowContainer>
              <RowContainer>
                <LinkLabel>Lng:</LinkLabel>
                <StaticLabel>{lng}</StaticLabel>
              </RowContainer>
            </>
          ) : (
            <>
              {inspectionData?.id && inspectionData?.inspectionDate && (
                <RowContainer data-testid="fleet-map-inspection-date">
                  <LinkLabel>Most Recent Inspection:</LinkLabel>
                  <Link
                    to={`/inspections/${inspectionData.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkTitle>{inspectionData.inspectionDate}</LinkTitle>
                  </Link>
                </RowContainer>
              )}
              {inspectionData?.maxSeverity && (
                <RowContainer data-testid="fleet-map-max-severity">
                  <LinkLabel>Max Severity: </LinkLabel>
                  <SeverityContainer>
                    <StyledCircle severity={inspectionData.maxSeverity} />
                    <LinkTitle>{inspectionData.maxSeverity}</LinkTitle>
                  </SeverityContainer>
                </RowContainer>
              )}
            </>
          )}
        </>
      ) : null}
    </>
  );
};

export default FleetMapDetail;
